<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="3">
          <b-link :to="{ name: 'MerchantsHostingPage-list' }">
            <feather-icon icon="ArrowLeftIcon" />
            <span class="align-middle ml-50">Back to List</span>
          </b-link>
        </b-col>
      </b-row>

      <b-card-header>
        <h3>Edit Merchant</h3>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="simpleRules">
          <form ref="form" @submit.stop.prevent="validationNewMerchantForm">
            <b-row>
              <b-col md="4">
                <b-form-group label="Merchant" label-for="Merchant">
                  <validation-provider #default="{ errors }" name="Merchant">
                    <b-form-select
                      id="Merchant-input"
                      v-model="editHosingPageMerchantFormData.merchantId"
                      :options="merchants"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Header Color" label-for="HeaderColor">
                  <validation-provider #default="{ errors }" name="HeaderColor">
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="HeaderColor-input"
                      v-model="editHosingPageMerchantFormData.headerColor"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Text Color" label-for="TextColor">
                  <validation-provider #default="{ errors }" name="TextColor">
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="TextColor-input"
                      v-model="editHosingPageMerchantFormData.textColor"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Button Color" label-for="ButtonColor">
                  <validation-provider
                    #default="{ errors }"
                    name="ButtonColor"
                    rules="required"
                  >
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="ButtonColor-input"
                      v-model="editHosingPageMerchantFormData.buttonColor"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Background Color"
                  label-for="BackgroundColor"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="BackgroundColor"
                    rules="required"
                  >
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="BackgroundColor-input"
                      v-model="editHosingPageMerchantFormData.backgroundColor"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Title Name" label-for="TitleName">
                  <validation-provider
                    #default="{ errors }"
                    name="TitleName"
                    rules="required"
                  >
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="TitleName-input"
                      v-model="editHosingPageMerchantFormData.titleName"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Title Color" label-for="TitleColor">
                  <validation-provider
                    #default="{ errors }"
                    name="TitleColor"
                    rules="required"
                  >
                    <b-form-input
                      v-on:paste="
                        (e) => {
                          e.preventDefault();
                          return false;
                        }
                      "
                      v-on:keypress="isLetterandNumber($event)"
                      id="TitleColor-input"
                      v-model="editHosingPageMerchantFormData.titleColor"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="Image" label-for="ImageURL">
                  <validation-provider #default="{ errors }" name="imageURL">
                    <b-form-file
                      id="file-default"
                      @change="changeImage"
                      :state="errors.length > 0 ? false : null"
                      accept="image/jpeg, image/png"
                    ></b-form-file>

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <br />
            <br />
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="validationNewMerchantForm"
            >
              Update
            </b-button>
          </form>
        </validation-observer>
      </b-card-body>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BCard,
  BButton,
  BFormCheckbox,
  BCardBody,
  BCardHeader,
  BFormSelect,
  BOverlay,
  BLink,
  BFormFile,
} from "bootstrap-vue";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import vSelect from "vue-select";

import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BCard,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    AppCollapse,
    AppCollapseItem,
    BCardBody,
    BCardHeader,
    vSelect,
    BOverlay,
    BLink,
    BFormFile,
  },
  data() {
    return {
      required,
      isLoading: false,
      editHosingPageMerchantFormData: {
        merchantIderchantId: null,
        headerColor: "",
        textColor: "",
        buttonColor: "",
        backgroundColor: "",
        titleName: "",
        titleColor: "",
        file: null,
      },
      merchants: [],
      isUploded: false,
    };
  },
  created() {
    this.fetchData();
  },
  destroyed() {},
  methods: {
    changeImage(event) {
      event.target.files[0]
        ? this.isUploded === true
        : (this.isUploded = false);
      this.editHosingPageMerchantFormData.logoPath = event.target.files[0];
    },
    isLetterandNumber(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z0-9_.,\s#]*$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z\s]*$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    dataURLtoFile(dataurl, filename) {
      fetch(dataurl)
        .then((res) => res.blob())
        .then((myBlob) => {
          const myFile = new File([myBlob], `${filename}`, {
            type: myBlob.type,
          });
          this.editHosingPageMerchantFormData.logoPath = myFile;
        });
    },
    validationNewMerchantForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          if (!this.isUploded) {
            this.dataURLtoFile(
              this.editHosingPageMerchantFormData.logoPath,
              `${this.editHosingPageMerchantFormData.titleName}`
            );
          }
          this.isLoading = true;
          const formData = new FormData();
          Object.keys(this.editHosingPageMerchantFormData).forEach((key) => {
            const value = this.editHosingPageMerchantFormData[key];
            formData.append(key, value);
          });
          axios
            .post(
              "/Merchant/api/V1.0/Merchants/UpdateMerchantDetail",
              formData,
              {
                headers: {
                  "Content-Type":
                    "multipart/form-data; boundary=<calculated when request is sent>",
                  Accept: "application/javascript",
                },
              }
            )
            .then((res) => {
              this.isLoading = false;
              this.$bvModal
                .msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then((result) => {
                  if (result) {
                    this.$router.push({ name: "MerchantsHostingPage-list" });
                  }
                });
            })
            .catch((res) => {
              this.isLoading = false;
              this.$bvModal.msgBoxOk(res.data.message, {
                title: "Error",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            });
        }
      });
    },
    fetchData() {
      this.isLoading = true;
      axios
        .get("/Merchant/api/V1.0/Merchants/GetMerchants")
        .then((res) => {
          res.merchants.forEach((item) => {
            this.merchants.push({
              value: item.id,
              text: item.name,
            });
          });
          // res.users.filter(f => f.accessType === 1).forEach(item => {
          //   this.users.push({
          //     value: item.id,
          //     text: item.username,
          //   })
          // })
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
      this.$store.dispatch("config/getActionPrivilege", "Merchants-View");
      axios
        .get(
          `/Merchant/api/V1.0/Merchants/GetMerchantDetail?merchantId=${this.$route.params.id}`
        )
        .then((res) => {
          this.editHosingPageMerchantFormData = res;
          // res.merchants.forEach((item) => {
          //   this.merchants.push({
          //     value: item.id,
          //     text: item.name,
          //   });
          // });
          // res.users.filter(f => f.accessType === 1).forEach(item => {
          //   this.users.push({
          //     value: item.id,
          //     text: item.username,
          //   })
          // })
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
